import React, {useContext} from 'react'
import { DarkModeContext } from '../../global/Theme'
import './index.sass'

export default function MessageHeader({queryType, emitQueryType}) {
    const { isDark } = useContext(DarkModeContext);

    return (
        <div id="newMessageWrapper" className={`${isDark ?  'new-msg-dark': 'new-msg-light' }`}>
            <h5>Messages</h5>
            <div className="messages-actions" > 
            <div className="img-search" > 
                <img onClick={e=>emitQueryType(1)} src={require('../../assets/icons/search.svg')}/>
                </div>
                <img onClick={e=>emitQueryType(2)} src={require('../../assets/icons/plus.svg')}/>
            </div>
        </div>
    )
}
